import { Grid, Typography } from "@mui/material";
import theme from "Theme/AppTheme";
import { observer } from "mobx-react";
import { useCurrentDashboard } from "../useCurrentDashboard";

/**
 * Renders the persisted, user-authored description for the current dashboard beneath the
 * dashboard title. Authored from the Edit Dashboard drawer (CustomizeDashboard).
 *
 * This is intentionally separate from StandardDashboardDescription, which renders fixed
 * explanatory copy for standard/system dashboards keyed off SignalsDashboardType.
 */
export const DashboardDescription = observer(() => {
    const currentDashboard = useCurrentDashboard();
    const description = currentDashboard?.description?.trim();

    if (!description) {
        return null;
    }

    return (
        <Grid item id="dashboard-description" sx={{ minWidth: 0 }}>
            <Typography
                sx={{
                    marginTop: theme.spacing(1),
                    color: theme.palette.gray.main,
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                    // Preserve author line breaks and keep long unbroken strings from
                    // pushing the header wider than its column.
                    whiteSpace: "pre-line",
                    overflowWrap: "anywhere",
                }}
            >
                {description}
            </Typography>
        </Grid>
    );
});

export default DashboardDescription;
